import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DisplayService, TranslationService } from 'src/app/my-sedgwick';
import { BaseComponent, UserActionService, UserRole } from '../../../shared';
import { Session } from '../../services/session.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReportNewClaimComponent } from '../report-new-claim/report-new-claim.component';
import { SupportDialogComponent } from '../support-dialog/support-dialog.component';
import { environment } from 'src/environments/environment';
import { UserRoleService } from '../../services/user-role.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Aliases } from '../../models/aliases';
import { isManagement, UserActions } from '../../../shared/models/user';
import { HelpItem } from '../..';
import { HelpfulLinkService } from '../../services/helpful-link.service';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-site-map',
    template: `
    <app-section class="tw-w-full">
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        class="tw-w-full"
        [title]="'Site Map' | translation: translationRequest"
        [headerLevel]="1"
        [canExpand]="false"
        >
        @if (session.user) {
          <ul class="app-pl5">
            @if (hasReportClaim) {
              <li>
                <h2 class="app-header-2">
                  <a
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="reportClaimLabel"
                    (keydown.enter)="reportClaim()"
                    (click)="reportClaim()"
                    >{{ reportClaimLabel }}</a
                    >
                  </h2>
                </li>
              }
              @if (
                this.session.user.leaveType &&
                this.session.user.leaveType.toLowerCase() === 'leavelink'
                ) {
                <li
                  >
                  <h2 class="app-header-2">
                    <a
                      tabindex="0"
                      role="button"
                      title="LeaveLink"
                      role="link"
                      (keydown.enter)="openLeavLink()"
                      (click)="openLeavLink()"
                      >{{ 'Access LeaveLink' | translation: translationRequest }}</a
                      >
                    </h2>
                  </li>
                }
                @if (showSummaryView) {
                  <li>
                    <h2 class="app-header-2">
                      <a
                        tabindex="0"
                        role="link"
                        aria-label="Summary view"
                        routerLink="/summary"
                        >{{ 'Summary view' | translation: translationRequest }}</a
                        >
                      </h2>
                    </li>
                  }
                  @if (display.managerView()) {
                    <li>
                      <h2 class="app-header-2">
                        <a
                          tabindex="0"
                          role="link"
                          aria-label="Manager view"
                          routerLink="/supervisor"
                          >{{ 'Manager view' | translation: translationRequest }}</a
                          >
                        </h2>
                      </li>
                    }
                    @if (display.controllerView()) {
                      <li>
                        <h2 class="app-header-2">
                          <a
                            tabindex="0"
                            role="link"
                            aria-label="Manager view"
                            routerLink="/controller"
                            >{{ 'Manager view' | translation: translationRequest }}</a
                            >
                          </h2>
                        </li>
                      }
                      @if (display.myClaimsView() && !session.isDelegating()) {
                        <li>
                          <h2 class="app-header-2">
                            <a
                              tabindex="0"
                              role="link"
                              aria-label="My claims"
                              routerLink="/dashboard"
                              >{{ 'My claims' | translation: translationRequest }}</a
                              >
                            </h2>
                          </li>
                        }
                        @if (
                          this.session.user.role !== 'AUDITOR' && this.display.commCenter
                          ) {
                          <li
                            >
                            <h2 class="app-header-2">
                              <a
                                tabindex="0"
                                routerLink="/communication-center"
                                title="Communication center"
                                role="link"
                                aria-label="Communication center"
                                >{{ 'Communication center' | translation: translationRequest }}</a
                                >
                              </h2>
                            </li>
                          }
                          @if (display.search) {
                            <li>
                              <h2 class="app-header-2">
                                <a
                                  routerLink="/search"
                                  title="Search"
                                  tabindex="0"
                                  role="link"
                                  aria-label="search"
                                  >{{ searchLabel | translation: translationRequest }}</a
                                  >
                                </h2>
                              </li>
                            }
                            @if (display.incidentalClient) {
                              <li>
                                <h2 class="app-header-2">
                                  <a
                                    role="link"
                                    aria-label="Absences"
                                    routerLink="/absence-dashboard"
                                    title="Absences"
                                    tabindex="0"
                                    >{{ 'Absences' | translation: translationRequest }}</a
                                    >
                                  </h2>
                                </li>
                              }
                              @if (!session.isDelegating() && display.watchList) {
                                <li>
                                  <h2 class="app-header-2">
                                    <a
                                      tabindex="0"
                                      routerLink="/watchlist"
                                      title="Watch List"
                                      role="link"
                                      aria-label="Watch list"
                                      >{{ 'Watch list' | translation: translationRequest }}</a
                                      >
                                    </h2>
                                  </li>
                                }
                                @if (!session.isDelegating() && display.history) {
                                  <li>
                                    <h2 class="app-header-2">
                                      <a
                                        routerLink="/history"
                                        title="History"
                                        tabindex="0"
                                        role="link"
                                        aria-label="History"
                                        >{{ 'History' | translation: translationRequest }}</a
                                        >
                                      </h2>
                                    </li>
                                  }
                                  @if (display.myWorkSchedule && !session.user.roles.auditor) {
                                    <li>
                                      <h2 class="app-header-2">
                                        <a
                                          tabindex="0"
                                          role="link"
                                          aria-label="My work schedule"
                                          routerLink="/my-work-schedule"
                                          title="My Work Schedule"
                                          >{{ 'My work schedule' | translation: translationRequest }}</a
                                          >
                                        </h2>
                                      </li>
                                    }
                                    @if (
                                      this.session.user.role !== 'AUDITOR' &&
                                      this.display.learningCenter
                                      ) {
                                      <li
                                        >
                                        <h2 class="app-header-2">
                                          <a
                                            tabindex="0"
                                            [queryParams]="{ focus: 'learningcenter' }"
                                            title="Helpful Resources"
                                            role="link"
                                            routerLink="/help"
                                            aria-label="Helpful Resources"
                                            >{{ 'Helpful resources' | translation: translationRequest }}</a
                                            >
                                          </h2>
                                          <ul class="app-pl2">
                                            @if (display.learningCenter) {
                                              <li>
                                                <h3 class="app-header-3">
                                                  <a
                                                    tabindex="0"
                                                    routerLink="/help"
                                                    [queryParams]="{ focus: 'learningcenter' }"
                                                    title="Learning center"
                                                    role="link"
                                                    aria-label="Learning center"
                                                    >{{ 'Learning Center' | translation: translationRequest }}</a
                                                    >
                                                  </h3>
                                                </li>
                                              }
                                              @if (hasLinks()) {
                                                <li>
                                                  <h3 class="app-header-3">
                                                    <a
                                                      tabindex="0"
                                                      routerLink="/help"
                                                      [queryParams]="{ focus: 'links' }"
                                                      title="Helpful links"
                                                      role="link"
                                                      aria-label="Helpful links"
                                                      >{{ 'Helpful links' | translation: translationRequest }}</a
                                                      >
                                                    </h3>
                                                  </li>
                                                }
                                                @if (hasVideos()) {
                                                  <li>
                                                    <h3 class="app-header-3">
                                                      <a
                                                        tabindex="0"
                                                        routerLink="/help"
                                                        [queryParams]="{ focus: 'videos' }"
                                                        title="Helpful videos"
                                                        role="link"
                                                        aria-label="Helpful videos"
                                                        >{{ 'Helpful videos' | translation: translationRequest }}</a
                                                        >
                                                      </h3>
                                                    </li>
                                                  }
                                                  @if (hasDocuments()) {
                                                    <li>
                                                      <h3 class="app-header-3">
                                                        <a
                                                          tabindex="0"
                                                          routerLink="/help"
                                                          [queryParams]="{ focus: 'documents' }"
                                                          title="Helpful documents"
                                                          role="link"
                                                          aria-label="Helpful documents"
                                                          >{{ 'Helpful documents' | translation: translationRequest }}</a
                                                          >
                                                        </h3>
                                                      </li>
                                                    }
                                                  </ul>
                                                </li>
                                              }
                                              @if (display.actAsDelegateSignal() && !session.isDelegating()) {
                                                <li>
                                                  <h2 class="app-header-2">
                                                    <a
                                                      tabindex="0"
                                                      routerLink="/act-as-delegate"
                                                      title="Act as delegate"
                                                      role="link"
                                                      aria-label="Act as delegate"
                                                      >{{ 'Act as delegate' | translation: translationRequest }}</a
                                                      >
                                                    </h2>
                                                  </li>
                                                }
                                                @if (
                                                  (manageDelegates || manageOthersDelegators) &&
                                                  !session.isDelegating()
                                                  ) {
                                                  <li
                                                    >
                                                    <h2 class="app-header-2">
                                                      <a
                                                        tabindex="0"
                                                        routerLink="/manage-delegates"
                                                        title="Manage delegates"
                                                        role="link"
                                                        aria-label="Manage delegates"
                                                        >{{ 'Manage delegates' | translation: translationRequest }}</a
                                                        >
                                                      </h2>
                                                    </li>
                                                  }
                                                  @if (!session.isDelegating()) {
                                                    <li>
                                                      <h2 class="app-header-2">
                                                        <a
                                                          routerLink="/PreferencesPage"
                                                          title="Account settings"
                                                          role="link"
                                                          aria-label="Account settings"
                                                          >{{ 'Account settings' | translation: translationRequest }}</a
                                                          >
                                                        </h2>
                                                      </li>
                                                    }
                                                    <li>
                                                      <h2 class="app-header-2">
                                                        <a
                                                          tabindex="0"
                                                          aria-label="Opens Technical Support popup"
                                                          (click)="openSupportDialog($event)"
                                                          (keydown.enter)="openSupportDialog($event)"
                                                          role="button"
                                                          >{{ 'Technical support' | translation: translationRequest }}</a
                                                          >
                                                        </h2>
                                                      </li>
                                                      <li>
                                                        <h2 class="app-header-2">
                                                          <a
                                                            tabindex="0"
                                                            href="https://www.sedgwick.com/privacy"
                                                            target="privacy-notice"
                                                            aria-label="Opens Privacy Policy"
                                                            role="link"
                                                            >{{ 'Privacy policy' | translation: translationRequest }}</a
                                                            >
                                                          </h2>
                                                        </li>
                                                        <li>
                                                          <h2 class="app-header-2">
                                                            <a
                                                              tabindex="0"
                                                              href="https://www.sedgwick.com/termsandconditions"
                                                              target="privacy-notice"
                                                              aria-label="Terms and conditions"
                                                              role="link"
                                                              >{{ 'Terms and conditions' | translation: translationRequest }}</a
                                                              >
                                                            </h2>
                                                          </li>
                                                          <li>
                                                            <h2 class="app-header-2">
                                                              @if (display.showHelpLink) {
                                                                <a
                                                                  tabindex="0"
                                                                  href="{{ helpUrl }}"
                                                                  target="privacy-notice"
                                                                  aria-label="open help"
                                                                  role="link"
                                                                  >{{ 'Help' | translation: translationRequest }}</a
                                                                  >
                                                              }
                                                            </h2>
                                                          </li>
                                                          </ul>
                                                        }
                                                      </app-panel>
                                                    </app-section>
    `,
    styles: [``],
    standalone: false
})
export class SiteMapPageComponent extends BaseComponent implements OnInit {
  hasReportClaim = false;
  development = false;
  helpUrl: string;
  showDelegationMenu = false;
  manageDelegates = false;
  actAsDelegate = false;
  manageOthersDelegators = false;
  searchLabel: string = 'Claim search';
  reportClaimLabel: string = '';
  isMgr: boolean;
  help: HelpItem[] = [];
  lcType: string;
  lob: string;
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  @ViewChild('dialogReportNewClaim') dialogRefReportNewClaim: TemplateRef<any>;
  @ViewChild('dialogReportNewClaimList')
  dialogRefReportNewClaimList: TemplateRef<any>;
  showSummaryView: boolean = false;

  constructor(
    public session: Session,
    public dialog: MatDialog,
    public display: DisplayService,
    public userRole: UserRoleService,
    public inpageAliasService: InpageAliasService,
    public claimConfigService: ConfigurationService,
    private userAction: UserActionService,
    public helpfulLinkService: HelpfulLinkService,
    private leaveLinkAccessService: LeaveLinkAccessService,
    private translationService: TranslationService
  ) {
    super();
  }

  async ngOnInit() {
    this.hasReportClaim = this.display.reportClaim;
    this.isMgr = isManagement(this.session.user.role.toUpperCase());
    this.showSummaryView = await this.display.summaryView();
    await this.loadHelpfulLinks();
    if (!this.claimConfigService.GetConfig.configFeatures) {
      await this.claimConfigService.initializeConfig();
    }

    this.development = !environment.production;
    this.helpUrl = environment.helpUrl;
    const delegationFeatures = await this.display.delegationFeatures();
    this.showDelegationMenu = delegationFeatures.showDelegationMenu;
    this.actAsDelegate = this.display.actAsDelegateSignal();
    this.manageDelegates = delegationFeatures.manageOwnDelegates;
    this.manageOthersDelegators = delegationFeatures.manageOthersDelegates;
    this.searchLabel =
      !this.session.user.isEmulating && this.userRole.auditor
        ? 'Search'
        : 'Claim search';
    this.reportClaimLabel = await this.inpageAliasService.get('ReportClaim');
  }

  reportClaim() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Confirmation',
    };
    const dlg = this.dialog.open(ReportNewClaimComponent, dialogConfig);
    dlg.addPanelClass('app-dlg-padding');
    dlg.updateSize('700px', '450px');
  }
  openLeavLink() {
    this.handleLeaveLinkAccess();
  }

  handleLeaveLinkAccess() {
    this.leaveLinkAccessService.handleLeaveLinkAccess();
  }
  openSupportDialog(event: Event): void {
    const dialogRef = this.dialog.open(SupportDialogComponent, {
      disableClose: true,
    });
    this.subs.sink = dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.dialog.closeAll();
      }
    });
    event.stopPropagation();
  }

  private async loadHelpfulLinks() {
    this.lcType = this.getLcType(this.lob);
    this.help = [];
    this.help = (await this.helpfulLinkService.getHelpfulLinks(
      this.lcType,
      true
    )) as HelpItem[];
  }

  getLcType(lob: string) {
    const lobTypes = ['WC', 'AU', 'GL', 'PR', 'PL']; // these have CLAIMANT and CONTROLLER type in setup app
    const mgrAction = this.userAction.getAction();
    if (lobTypes.includes(lob)) {
      if (
        (this.isMgr &&
          (mgrAction == UserActions.ViewOwnMgrDb ||
            mgrAction == UserActions.MgrViewEmpClaim ||
            mgrAction == UserActions.MgrViewEmpDb)) ||
        this.userRole.controller
      ) {
        return 'CONTROLLER';
      } else {
        return 'HRM';
      }
    } else {
      if (
        (this.isMgr &&
          (mgrAction == UserActions.ViewOwnMgrDb ||
            mgrAction == UserActions.MgrViewEmpClaim ||
            mgrAction == UserActions.MgrViewEmpDb ||
            mgrAction == UserActions.ManagerSummaryView)) ||
        this.userRole.controller
      ) {
        return this.session.user.role.toUpperCase();
      } else {
        return 'HRM';
      }
    }
  }

  hasLinks(): boolean {
    return this.help.some(
      (item) =>
        item.description === 'Helpful Links' && item.count && item.count > 0
    );
  }

  hasVideos(): boolean {
    return this.help.some(
      (item) =>
        item.description === 'Helpful Videos' && item.count && item.count > 0
    );
  }

  hasDocuments(): boolean {
    return this.help.some(
      (item) =>
        item.description === 'Documents and FAQs' &&
        item.count &&
        item.count > 0
    );
  }
}
